import DashbordIcon from "src/assets/images/dashboard_icon.svg";
import RadarCheckIcon from "src/assets/images/radar_check_icon.svg";
import RadarProfileIcon from "src/assets/images/radar_profile.svg";
import RadarRulesIcon from "src/assets/images/radar_rules.svg";
import ReportIcon from "src/assets/images/reports.svg";
import SettingIcon from "src/assets/images/setting.svg";
import SpotlightIcon from "src/assets/images/spotlight___icon.svg";
import KeysIcon from "src/assets/images/icon_key.svg";
import WalletIcon from "src/assets/images/icon_wallet.svg";
import DocumentationIcon from "src/assets/images/document.svg";
import TransactionMonitoringIcon from "src/assets/images/transaction_monitoring_icon.svg";
import BackOfficeIcon from "src/assets/images/back_office.svg";

type Props = {
  name: string;
  icon: string;
  module: string;
  path?: string;
  dropdown?: boolean;
  children?: any;
  className?: string;
  is_beta?: boolean;
};

const host = window.location.host;

export const SIDENAVS: Props[] = [
  {
    name: host === "intel.peleza.com" ? "AML Spotlight" : "Radar Spotlight",
    path:
      host === "intel.peleza.com"
        ? "/app/aml-spotlight"
        : "/app/radar-spotlight",
    module: host === "intel.peleza.com" ? "aml-spotlight" : "radar-spotlight",
    icon: SpotlightIcon,
    className: "first-step",
    is_beta: false,
  },
  {
    name: "Dashboard",
    path: "/app/dashboard",
    module: "dashboard",
    icon: DashbordIcon,
    className: "second-step",
    is_beta: false,
  },
  {
    name: "Radar Check",
    path: "/app/radar-check?q=individual&check_type=name_screening",
    module: "radar-check",
    icon: RadarCheckIcon,
    className: "third-step",
    is_beta: false,
  },
  {
    name: "Check History",
    path: "/app/check-history?tab=single&page=1",
    module: "check-history",
    icon: RadarProfileIcon,
    className: "fourth-step",
    is_beta: false,
  },
  {
    name: "Transaction Monitoring",
    path: "/app/transaction-monitoring/dashboard-overview",
    module: "transaction-monitoring",
    icon: TransactionMonitoringIcon,
    dropdown: true,
    is_beta: true,
    children: [
      {
        name: "Dashboard",
        path: "/app/transaction-monitoring/dashboard-overview",
      },
      {
        name: "Feeds",
        path: "/app/transaction-monitoring/feeds",
      },
      {
        name: "Fraud alerts",
        path: "/app/transaction-monitoring/fraud-alerts",
      },
      {
        name: "Assign",
        path: "/app/transaction-monitoring/assign",
      },
      // {
      //   name: "Investigation tools",
      //   path: "/app/transaction-monitoring/investigation-tools",
      // },
    ],
  },
  {
    name: host === "intel.peleza.com" ? "AML Rules" : "Radar Rules",
    path:
      host === "intel.peleza.com"
        ? "/app/aml-rules?tab=onboarding-rules&q=all-rules"
        : "/app/radar-rules?tab=onboarding-rules&q=all-rules",
    module: host === "intel.peleza.com" ? "aml-rules" : "radar-rules",
    icon: RadarRulesIcon,
    className: "fifth-step",
    is_beta: false,
  },
  {
    name: "Back Office",
    path: "/app/back-office/screening-alert?page=1",
    module: "back-office",
    icon: BackOfficeIcon,
    dropdown: true,
    is_beta: false,
    children: [
      {
        name: "Screening Alert",
        path: "/app/back-office/screening-alert?page=1&tab=single",
      },
      {
        name: "User Monitoring",
        path: "/app/back-office/user-monitoring?page=1&tab=single",
      },
    ],
    className: "sixth-step",
  },
  {
    name: host === "intel.peleza.com" ? "AML Analytics" : "Radar Analytics",
    path:
      host === "intel.peleza.com"
        ? "/app/aml-analytics"
        : "/app/radar-analytics",
    module: host === "intel.peleza.com" ? "aml-analytics" : "radar-analytics",
    icon: ReportIcon,
    className: "seventh-step",
    is_beta: false,
  },
  {
    name: "Wallet",
    path: "/app/wallet?q=subscription",
    module: "wallet",
    icon: WalletIcon,
    className: "eight-step",
    is_beta: false,
  },
  {
    name: "API/SDK",
    path: "/app/configuration",
    module: "configuration",
    icon: KeysIcon,
    className: "night-step",
    is_beta: false,
  },
  {
    name: "Documentation",
    path:
      host === "intel.peleza.com"
        ? "https://amlreadmeio.readme.io/reference/post_radar-api-v1-onboarding-screening-verify"
        : "https://identityradar.readme.io/reference/post_radar-api-v1-onboarding-screening-verify",
    module: "documentation",
    icon: DocumentationIcon,
    className: "tenth-step",
    is_beta: false,
  },
  {
    name: "Settings",
    path: "/app/settings?tab=user-profile",
    module: "settings",
    icon: SettingIcon,
    className: "eleventh-step",
    is_beta: false,
  },
];
